module.exports = __webpack_public_path__ + "static/img/8-juniper.01b10a23.png";